import { render, staticRenderFns } from "./CreateBrandMonitoringPopup.vue?vue&type=template&id=1f76e119&scoped=true&"
import script from "./CreateBrandMonitoringPopup.vue?vue&type=script&lang=ts&"
export * from "./CreateBrandMonitoringPopup.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBrandMonitoringPopup.vue?vue&type=style&index=0&id=1f76e119&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76e119",
  null
  
)

export default component.exports